import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Container = styled("div")`
    pointer-events: none;
    touch-action: none;
    & * {
        pointer-events: auto;
        touch-action: auto;
    }
`

export const StyledTypography = styled(Typography)`
    font-family: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    text-transform: ${({theme}) => theme.uxfabric.global.subtitle2.textTransform};
`
